<template>
  <v-col cols="12">
    <v-progress-linear
      :value="coreCard.percentComplete"
      :color="
        $coreScores.getColor(
          $coreScores.reverseFormat(coreCard.percentComplete)
        )
      "
      background-color="background"
      height="30"
      class="my-0"
    >
      <template v-slot:default="{}">
        <div
          v-bind:style="{
            marginLeft: margin
          }"
          class="benchmark"
        >
          &nbsp;
        </div>
      </template>
    </v-progress-linear>
    <div>
      <v-icon
        v-bind:style="{
          marginLeft: iconMargin
        }"
        x-small
        color="secondarytext"
      >
        insert_chart
      </v-icon>
    </div>
    <div v-if="showPossible">
      {{ coreCard.value }} of {{ coreCard.possible }} completed
    </div>
  </v-col>
</template>

<script>
export default {
  name: "CoreCardProgress",
  props: {
    coreCard: { type: Object },
    showPossible: { type: Boolean, default: false }
  },
  computed: {
    margin() {
      return (this.coreCard.benchmark - 50) * 2 + "%";
    },
    iconMargin() {
      return `calc(${this.coreCard.benchmark}% - 6px)`;
    }
  }
};
</script>

<style lang="scss" scoped>
.benchmark {
  border-left: 2px dashed var(--v-secondarytext-base);
  padding-top: 20px;
  padding-bottom: 20px;
  width: 2px;
}
</style>
